import { User } from '@barracuda/shared';
import { HeaderNavBarLink } from './HeaderNavBarLink';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

interface ILinks {
  label: string;
  to: string;
  key: string;
  replace?: boolean;
}

const LOGGED_IN_LINKS: ILinks[] = [
  {
    label: 'menuLabels.myTests',
    to: '/dashboard/tests',
    key: 'dashboard',
    replace: false
  },
  {
    label: 'menuLabels.practice',
    to: '/dashboard/practice',
    key: 'practice',
    replace: false
  }
];

const NOT_LOGGED_IN_LINKS: ILinks[] = [
  {
    label: 'menuLabels.testFormats',
    to: '/test-format',
    key: 'test-formats',
    replace: false
  },
  {
    label: 'menuLabels.forInstitutions',
    to: '/for-institutions',
    key: 'for-institutions',
    replace: false
  }
];

const useGenerateLinks = ({ isLoggedIn, user }: { isLoggedIn?: boolean; user?: User }) => {
  const { t } = useTranslation();

  const links = useMemo(() => {
    const arrayToProcess = user && isLoggedIn ? LOGGED_IN_LINKS : NOT_LOGGED_IN_LINKS;
    return arrayToProcess.map((link) => ({
      ...link,
      label: t(link.label)
    }));
  }, [t, user, isLoggedIn]);

  const linkComponents = useMemo(
    () =>
      links.map((link, index) => (
        <HeaderNavBarLink link={link} key={`navbar-${index}`} index={index} />
      )),
    [links]
  );

  return { links: linkComponents };
};

export default useGenerateLinks;
